import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import logoCentre from '../assets/images/logoCentre.PNG';

export default function CustomBackdrop({
  open,
  setOpen
}) {
  return (
    <Backdrop
      sx={{
        backgroundColor: 'rgba(255, 255, 255, 1)',
        color: '#A31732',
        zIndex: 2000,
      }}
      open={open}
      onClick={() => setOpen(false)}
    >
      <div className='flex justify-center items-center gap-5'>
        <img src={logoCentre} className='w-64 relative left-1' alt='logo' />
        <CircularProgress color="inherit" />
      </div>
    </Backdrop>
  )
}
